import { Link } from "react-router-dom";
import { LOGO } from "../lib/content";

// Official DST logo image.
export const Logo = ({ className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`flex items-center ${className}`}>
    <span className="bg-white rounded-md px-3 py-1.5 inline-flex items-center shadow-md">
      <img src={LOGO} alt="DST — Dynamic Sports Training" className="h-9 sm:h-11 w-auto object-contain" />
    </span>
  </Link>
);
